export default __webpack_public_path__ + "static/media/pic8.05d5847d.jpg";